import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { GiftCard } from 'src/app/shared-core/models/checkout-data.model';
import { CheckoutService } from 'src/app/shared-core/services/checkout.service';
import { hasError } from 'src/app/shared-core/services/validation.service';

@Component({
  selector: 'app-gift-cards',
  templateUrl: './gift-cards.component.html',
  styleUrls: ['./gift-cards.component.scss'],
})
export class GiftCardsComponent implements OnInit {
  card: GiftCard;
  isAddingGiftCard: boolean = false;
  giftCardForm: FormGroup;
  @ViewChild('cardInput') cardInputElement: ElementRef;

  constructor(
      private _service: CheckoutService,
      private _formBuilder: FormBuilder, 
      private _toaster: ToastService
  ) {
    _service.CheckoutDataSubject.subscribe((m) => {
      this.card = m?.Payments?.GiftCard;
    });
  }
  ngOnInit(): void {
    this.giftCardForm = this._formBuilder.group({
      Card: [null, [Validators.required]],
      Pin: [null, [Validators.required]],
    });
  }

  add(event: UIEvent): void {
    this.isAddingGiftCard = true;
    event.preventDefault();
    this.giftCardForm.reset();
    setTimeout(() => {
      this.cardInputElement.nativeElement.focus();
    });
  }

  remove() {
    this._service.removeGiftCard().subscribe();
  }

  onSubmit() {
    if (!this.giftCardForm.valid) {
      return;
    }

    this._service
      .addGiftCard(this.giftCardForm.value as GiftCard)
      .subscribe(
        (r) => {
          this.isAddingGiftCard = false;
          this.giftCardForm.reset();
        },
        (resp) => {
          if (Math.floor(resp.status / 100) !== 4) {
            throw resp.error;
          }
          if (typeof resp.error === 'string') {
            this._toaster.error(resp.error);
            return;
          }
          for (let f in resp.error) {
            if (this.giftCardForm.controls[f]) {
              this.giftCardForm.controls[f].setErrors({ server: resp.error[f] });
            } else {
              this._toaster.error(resp.error[f]);
            }
          }
        }
      );
  }

  cancel() {
    this.isAddingGiftCard = false;
  }
  hasError = (formControlName: string, error: string | string[] = null): boolean => {
    return hasError(this.giftCardForm, formControlName, error);
  };
}
